import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {SelectItem} from 'primeng/api';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {DadProductService} from '../../services/dad-product.service';

@Component({
  selector: 'app-dad-product-price-crud',
  templateUrl: './dad-product-price-crud.component.html',
  styleUrls: ['./dad-product-price-crud.component.scss']
})
export class DadProductPriceCrudComponent implements OnInit {

  dadProductPriceForm: UntypedFormGroup;
  currenciesList: SelectItem[];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private dadProductService: DadProductService) {
  }

  ngOnInit() {
    this.createFormGroup();
    this.initCurrencySelectList();
    this.initialiseFormGroup();
  }

  private initCurrencySelectList() {
    this.currenciesList = [
      {label: 'USD', value: 'USD'},
      {label: 'EUR', value: 'EUR'},
      {label: 'CHF', value: 'CHF'},
      {label: 'GBP', value: 'GBP'},
      {label: 'JPY', value: 'JPY'},
      {label: 'SGD', value: 'SGD'},
    ];
  }

  private initialiseFormGroup() {
    const selectedDadProduct = this.config.data['selectedDadProduct'];
    this.dadProductPriceForm.get('market').setValue(this.config.data['selectedMarket'].name);
    this.dadProductPriceForm.get('productType').setValue(selectedDadProduct ? selectedDadProduct.productType : 'Standard product code');
    this.dadProductPriceForm.get('productCode').setValue(selectedDadProduct ? selectedDadProduct.productCode : '');
  }

  createFormGroup() {
    this.dadProductPriceForm = this.formBuilder.group(
      {
        id: [''],
        market: [''],
        productType: [''],
        productCode: ['', Validators.required],
        amount: ['0', Validators.required],
        currency: ['USD'],
        startDate: [new Date()],
      },
    );
  }

  addDadProductPrice() {
    this.dadProductService.createDadProduct(this.dadProductPriceForm.value).subscribe(
      res => {
        this.dadProductPriceForm.get('id').setValue(res['id']);
        this.ref.close(this.dadProductPriceForm.value);
      }
    );
  }

}
